/** `Pressable`'s own default hold length, in ms. */
export const DEFAULT_DELAY_LONG_PRESS_MS = 500;
